import React from "react"

import { Button } from "../../components/shared/Buttons"

const BlogPostActionBar = ({
  saving,
  canSaveDraft,
  canPublish,
  canPreview,
  onSaveDraft,
  onPreview,
  onPublish,
  onCancel
}) => (
  <div className="sticky bottom-0 z-10 -mx-4 mt-10 border-t border-builder-border-light bg-white px-4 py-6 md:-mx-8 md:px-8">
    <div className="mx-auto flex max-w-splash-container flex-wrap items-center justify-center gap-4">
      <Button
        type="button"
        className="border-builder-border bg-white text-builder-primary hover:bg-gray-50"
        onClick={onCancel}
        disabled={saving}>
        Cancel
      </Button>
      <Button
        type="button"
        className="border-builder-border bg-white text-builder-primary hover:bg-gray-50"
        onClick={onSaveDraft}
        disabled={saving || !canSaveDraft}>
        Save draft
      </Button>
      <Button
        type="button"
        className="border-builder-border bg-white text-builder-primary hover:bg-gray-50"
        onClick={onPreview}
        disabled={saving || !canPreview}>
        Preview
      </Button>
      <Button type="button" onClick={onPublish} disabled={saving || !canPublish}>
        Publish
      </Button>
    </div>
  </div>
)

export default BlogPostActionBar
